<script setup lang="ts">
const { t } = useTexts();
const { resetCurrentMenuOpen } = useAccountMenuStore();

useSeo({
  title: t('account_menu.rewards'),
});

onMounted(() => {
  resetCurrentMenuOpen();
});
</script>

<template>
  <UserAccountPageLayout :title="$t('account_menu.rewards')">
    <UserRewards />
  </UserAccountPageLayout>
</template>

<style module lang="scss">
// style
</style>
